/**
 * Canguaru Lottie runtime · "breathing" icons.
 * Ported behaviourally from canguaru-site-v2.html closing script.
 *
 * Markup contract:
 *   <span class="cg-lot" data-lottie="{json url}" data-hover-parent=".cg-path">
 *     <img src="{static fallback}" alt="">  (or inline SVG.cg-static)
 *   </span>
 *
 * Behaviour: play on scroll into view, replay every ~6s while visible,
 * pause off-screen, hover replays, static fallback stays for errors and
 * prefers-reduced-motion. Library: lottie-web (self-hosted asset), loaded
 * lazily only when a .cg-lot exists on the page.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var els = document.querySelectorAll('.cg-lot[data-lottie]');
  if (!els.length) return;

  function boot() {
    if (!window.lottie) return;
    var anims = [];

    els.forEach(function (el) {
      if (el.dataset.cgLottieReady) return;
      el.dataset.cgLottieReady = '1';
      var holder = document.createElement('div');
      holder.style.cssText = 'position:absolute;inset:0';
      el.appendChild(holder);
      try {
        var anim = window.lottie.loadAnimation({
          container: holder,
          path: el.dataset.lottie,
          renderer: 'svg',
          loop: false,
          autoplay: false,
        });
        anim.addEventListener('data_ready', function () {
          var fallback = el.querySelector('img, svg.cg-static');
          if (fallback) fallback.style.display = 'none';
        });
        var hoverTarget = el.dataset.hoverParent ? el.closest(el.dataset.hoverParent) || el : el;
        hoverTarget.addEventListener('mouseenter', function () {
          anim.goToAndPlay(0, true);
        });
        anims.push({ el: el, anim: anim, visible: false, timer: null });
      } catch (e) {
        /* static fallback stays visible */
      }
    });

    function breathe(rec) {
      rec.anim.goToAndPlay(0, true);
      rec.timer = setTimeout(function () {
        if (rec.visible) breathe(rec);
      }, 6000 + Math.random() * 1500);
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var rec = null;
          for (var i = 0; i < anims.length; i++) {
            if (anims[i].el === entry.target) {
              rec = anims[i];
              break;
            }
          }
          if (!rec) return;
          if (entry.isIntersecting && !rec.visible) {
            rec.visible = true;
            breathe(rec);
          } else if (!entry.isIntersecting && rec.visible) {
            rec.visible = false;
            clearTimeout(rec.timer);
            rec.anim.pause();
          }
        });
      },
      { threshold: 0.25 }
    );
    anims.forEach(function (a) {
      io.observe(a.el);
    });
  }

  if (window.lottie) {
    boot();
  } else {
    var src = document.currentScript && document.currentScript.dataset.lottieLib;
    if (!src) return;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = boot;
    document.head.appendChild(s);
  }
})();
